import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  NOTIFICATION_FEATURE_KEY,
  State,
  NotificationPartialState,
  notificationAdapter
} from './notification.reducer';

// Lookup the 'Notification' feature state managed by NgRx
export const getNotificationState = createFeatureSelector<
  NotificationPartialState,
  State
>(NOTIFICATION_FEATURE_KEY);

const { selectAll, selectEntities } = notificationAdapter.getSelectors();

export const getNotificationLoading = createSelector(
  getNotificationState,
  (state: State) => state.loading
);

export const getNotificationError = createSelector(
  getNotificationState,
  (state: State) => state.error
);

export const getAllNotification = createSelector(
  getNotificationState,
  (state: State) => selectAll(state)
);

export const getNotificationEntities = createSelector(
  getNotificationState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getNotificationState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getNotificationEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

// export const getMaxId = createSelector(getNotificationEntities, entities => {
//   let maxId = 0;
//   Object.keys(entities).map(
//     id => (maxId = parseInt(id, 10) > maxId ? parseInt(id, 10) : maxId)
//   );

//   return maxId;
// });
